import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Metall.module.css'; // Создадим этот файл стилей позже
import Banner from '../sections/Banner/Banner';
import Cards from '../../../components/CardsUI/Cards/Cards';
import Table from '../sections/Table/Table';
import ServicesDescription from '../../../components/EntToEndUI/ServicesDescription/ServicesDescription';
import { PhoneLineIcon, FileIcon, PlaneIcon, CraneIcon } from '../../../components/Other/Icons/Icons';
import RequestForm from '../../../components/EntToEndUI/RequestForm/RequestForm';
import MetallPriceTable from '../../../components/Tables/MetallPriceTable/MetallPriceTable';
import PageTitle from '../../../components/Other/PageTitle/PageTitle';

const Metall = () => {
  const serviceType = 'metall'
  const { t } = useTranslation();
  const cards = [
    {
      title: 'БАЛКИ, КРОВЕЛЬНЫЕ ПРОГОНЫ',
      description: 'Балки — горизонтальные элементы, способные переносить нагрузки от других частей конструкции. Балки часто используются в строительстве зданий для поддержания стен, перекрытий и крыш.',
      image: '/images/cards/metall/1.png',
    },
    {
      title: 'ФЕРМЫ СТРОПИЛЬНЫЕ И ТРЕХМЕРНЫЕ',
      description: 'Фермы — это конструкции из стоек, стропил и прогонов, соединенных в жесткую раму. Они применяются для каркасов крыш разных форм и размеров.',
      image: '/images/cards/metall/2.png',
    },
    {
      title: 'КОЛОННЫ РЯДОВЫЕ И ТРЕХМЕРНЫЕ',
      description: 'Колонны — вертикальные опоры, поддерживающие перекрытия, крыши и другие части здания, создающие вертикальные нагрузки.',
      image: '/images/cards/metall/3.png',
    },
    {
      title: 'СВЯЗИ, ФАХВЕРКОВЫЕ КОНСТРУКЦИИ',
      description: 'Фахверки — плоские металлические конструкции из прогонов и стоек, соединенных сваркой. Используются для перекрытий, обеспечивая поддержку покрытий зданий.',
      image: '/images/cards/metall/4.png',
    },
    {
      title: 'СЦЕНИЧЕСКИЕ КОНСТРУКЦИИ',
      description: 'Сценические конструкции — это фермовые системы из труб и перемычек, обеспечивающие функциональность сцены и её поддержку.',
      image: '/images/cards/metall/5.png',
    },
    {
      title: 'ДЕКОРАЦИИ, МАФы',
      description: 'МАФы — небольшие сооружения, организующие пространство и украшающие территорию. Они выполняют практические и декоративные функции, например, скамейки для отдыха и арт-объекты для эстетики.',
      image: '/images/cards/metall/6.png',
    },
    {
      title: 'РЕКЛАМНЫЕ КОНСТРУКЦИИ',
      description: 'Рекламные конструкции — стационарные носители наружной рекламы, связанные с недвижимостью. Их размещают на стенах, крышах зданий, сооружениях и остановках общественного транспорта.',
      image: '/images/cards/metall/7.png',
    },
  ];

  const metallConstructionPriceData = [
    {
      name: 'Колонны несущие',
      price: 'от 36 400 руб./т'
    },
    {
      name: 'Колонны пространственные',
      price: 'от 36 400 руб./т'
    },
    {
      name: 'Фермы',
      price: 'от 37 700 руб./т'
    },
    {
      name: 'Вертикальные и горизонтальные связи',
      price: 'от 33 800 руб./т'
    },
    {
      name: 'Прогоны',
      price: 'от 32 500 руб./т'
    },
    {
      name: 'Балки перекрытий',
      price: 'от 39 390 руб./т'
    },
    {
      name: 'Балки подкрановые',
      price: 'от 39 250 руб./т'
    },
    {
      name: 'Балки из сварного двутавра',
      price: 'от 38 350 руб./т'
    },
    {
      name: 'Лестничные марши со ступенями',
      price: 'от 57 200 руб./т'
    },
    {
      name: 'Ограждения',
      price: 'от 62 400 руб./т'
    },
    {
      name: 'Площадки обслуживания',
      price: 'от 45 500 руб./т'
    },
    {
      name: 'Эстакады',
      price: 'от 37 960 руб./т'
    },
    {
      name: 'Нориийные вышки',
      price: 'от 49 400 руб./т'
    },
    {
      name: 'Ригели',
      price: 'от 36 400 руб./т'
    },
    {
      name: 'Анкерные группы',
      price: 'от 40 300 руб./т'
    }
  ];

  const items = [
    {
      icon: <PhoneLineIcon />,
      description: t('services.metall.info.phone')
    },
    {
      icon: <FileIcon />,
      description: t('services.metall.info.file')
    },
    {
      icon: <PlaneIcon />,
      description: t('services.metall.info.plane')
    },
    {
      icon: <CraneIcon />,
      description: t('services.metall.info.crane')
    }
  ];

  return (
    <div className="service-page">
      <PageTitle title={t('services.metall.title')} />
      <Banner serviceType={serviceType} Image={'/images/cards/metall/metall.png'} showDescription={false}/>
      <Cards cards={cards} maxCardHeight={'190px'} maxCardWidth={'340px'} maxCardsWidth={'100%'} maxCardTitleHeight={'54px'}/>
      <MetallPriceTable 
        title={t('services.metall.table.title')}
        subtitle={t('services.metall.table.subtitle')}
        data={metallConstructionPriceData} 
        tableTitle={t('services.metall.table.tableTitle')}
        tableSubTitle={t('services.metall.table.tableSubTitle')}
        priceTitle={t('services.metall.table.tablePriceTitle')}
        buttonText={t('services.metall.table.buttonText')}
        buttonLink={t('services.metall.table.buttonLink')}
        buttonTitle={t('services.metall.table.buttonTitle')}
      />
      <ServicesDescription items={items} />
      <RequestForm />
    </div>
  );
};

export default Metall; 